<template>
  <div>
    <mermaid-chart :graph-definition="mermaidCode" />
  </div>
</template>

<script>
import MermaidChart from '@/components/inc/MermaidChart.vue';

export default {
  components: { MermaidChart },
  data() {
    return {
      mermaidCode: `
        graph LR
        A[2025] -->|智能化生产| B(45%)
        A -->|环保包装| C(15%)
        D[2030] -->|智能化生产| E(65%)
        D -->|环保包装| F(45%)
        D -->|个性化定制| G(35%)
      `
    };
  }
};
</script>